import React, { useState, useContext, useRef } from 'react'
import { useParams, Link } from 'react-router-dom'
import { Context } from '../../Context'

import { ProgramService } from '../../services/Program'
import { CoursesService } from '../../services/Courses'
import { DataListCourses } from '../../components/DataListCourses'
import { Layout } from '../../components/Layout'
import { GLOBALS } from '../../utils/Globals'
import { Button } from 'primereact/button'
import { Message } from 'primereact/message'

export const Program = () => {
  const { isAuth: token } = useContext(Context)
  const { id: program } = useParams()

  const [isLoading, setIsLoading] = useState(false)
  const [programData, setProgram] = useState([])
  const [error, setError] = useState(null)

  const dt = useRef(null)

  const config = {
    title: programData.name,
    icon: GLOBALS.menu.programs.icon,
    backlink: GLOBALS.menu.courses.link,
  }

  const columns = [
    {
      field: 'name',
      header: 'Nombre',
      sortable: true,
      filter: true,
      filterPlaceholder: 'Buscar por nombre de curso',
    },
    {
      field: 'version',
      header: 'Version',
      sortable: true,
      filter: true,
      filterPlaceholder: 'Buscar por version',
    },
    {
      field: 'status',
      header: 'Estado',
      sortable: true,
      filter: false,
    },
    {
      field: 'created_at',
      header: 'Fecha de creacion',
      sortable: true,
      filter: true,
      filterPlaceholder: 'Buscar por fecha de creacion',
    },
  ]

  const getCoursesByProgramId = async () => {
    try {
      const programData = await ProgramService.getById(program, token);
      setProgram(programData);

      return programData.courses;
    } catch (e) {
      setError(e.message)
    } finally {
      setIsLoading(false)
    }
  }

  const customActionButtons = ({ row }) => {
    return (
      <Link to={`${GLOBALS.menu.courses.viewcourse}/${row.id}`}>
        <Button
          type="button"
          icon="pi pi-chevron-circle-right"
          className="p-button-primary"
          tooltip="Ver"
        ></Button>
      </Link>
    )
  }

  return (
    <Layout>
      <>
        {isLoading ? (
          <div className="loading-container">
            <i className="pi pi-spin pi-spinner" style={{ fontSize: '4em' }}></i>
          </div>
        ) : error ? (
          <Message severity="error" text={error}></Message>
        ) : (
          
          <div className="p-grid">
            <div className="p-col-12">
              <div className="card">
                <div className="title-wrap">

                  <h1 className="create-edit-title">
                    {config.icon && <i className={config.icon}></i>}
                    {config.title}
                  </h1>

                </div>

                <DataListCourses
                  customActionButtons={customActionButtons}
                  ref={dt}
                  menuItem={GLOBALS.menu.courses}
                  listItems={() => getCoursesByProgramId()}
                  bulkDelete={(ids) => CoursesService.bulkDelete(ids, token)}
                  columns={columns}
                ></DataListCourses>

              </div>
            </div>
            <div className="p-col-12"></div>
          </div>
        )}
      </>
    </Layout>
  )
}
